var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value && !_vm.inlineMode)?_c('el-tag',{attrs:{"size":_vm.size}},[_vm._v(_vm._s(_vm.getText()))]):(_vm.value && _vm.inlineMode)?_c('span',[_vm._v(_vm._s(_vm.getText()))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }